import * as _ from 'lodash'
import React from 'react';
import jobCostScheduleItemFactory from '../models/jobCostScheduleItemModel';
import componentServices from '../componentServices';
import * as contractorActions from '../contractorActions';
import * as reportActions from '../reportActions';
import { searchJobs } from '../jobActions';
import { pushAlert } from '../actions';
import enums from '../enum';
import util from '../util';
import valueFilters from '../valueFilters';
import globalRelay from '../globalRelay';
import { AsyncButton, Radio } from './sharedComponents';
import { getCollection, getModel, ModelCollection } from 'Scripts/store';

const formatAddress = address => {
	return address ? `${address.street}, ${address.city}, ${address.region} ${address.postalCode}` : '';
};

const JobCostPreOrderContract = ({ accountingIdRow, affirmedRow, firstJobContract, job, jobTypeName, summary, actionButton, rejectionNoteRow }) => {
	const budgetValues = summary.extensionItems.filter(item => item.group === 'accounting');
	const firstContractLabel = `Original ${globalRelay.config!.getString('Accounting ID', 'job')}`;
	const budgetValueRows = _.map(budgetValues || [], (v, i) => (<tr key={i}>
		<td />
		<td><strong>{v.itemNote}</strong></td>
		<td>{util.formatAsCurrency(v.type === 'budget-cost' ? v.cost : v.sellPrice)}</td>
		<td />
	</tr>));

	return (
		<section className="jobCostFinalize">
			{ /* Final Details */}
			<section>
				<header>
					<span>PRE-ORDER</span>
				</header>
				<div className="inner compact">
					<table cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td><strong>Job Type</strong></td>
								<td>{jobTypeName}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Billing Address</strong></td>
								<td>{formatAddress(job.billingAddress)}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Delivery Address</strong></td>
								<td>{formatAddress(job.workSiteAddress)}</td>
								<td />
							</tr>
							{budgetValueRows}
							{!firstJobContract ? null : <tr>
								<td />
								<td><strong>{firstContractLabel}</strong></td>
								<td>{firstJobContract.accountingId}</td>
								<td />
							</tr>}
							{accountingIdRow}
							{affirmedRow}
							{rejectionNoteRow}
							<tr>
								<td />
								<td />
								<td>{actionButton}</td>
								<td />
							</tr>
						</tbody>
					</table>
				</div>
			</section>

		</section>
	);
};

const JobCostPreOrderChangeOrder = ({ accountingIdRow, affirmedRow, changeOrder, summary, actionButton, rejectionNoteRow }) => {
	const budgetValues = summary.extensionItems.filter(item => item.group === 'accounting');
	const parentContractLabel = `Original ${globalRelay.config!.getString('Accounting ID', 'job')}`;
	const amount = summary.grandTotalContract;
	const budgetValueRows = _.map(budgetValues || [], (v, i) => (<tr key={i}>
		<td />
		<td><strong>{v.itemNote}</strong></td>
		<td>{util.formatAsCurrency(v.type === 'budget-cost' ? v.cost : v.sellPrice)}</td>
		<td />
	</tr>));

	return (
		<section className="jobCostFinalize">
			{ /* Final Details */}
			<section>
				<header>
					<span>PRE-ORDER</span>
					<div className="actions" />
				</header>
				<div className="inner compact">
					<table cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td><strong>{changeOrder.type === 'change-order' ? 'Change Order Name' : 'Billing Adjustment Name'}</strong></td>
								<td>{changeOrder.name}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Reason</strong></td>
								<td>{changeOrder.description}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Bill or Pay To</strong></td>
								<td>{changeOrder.transactionAccount}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Amount</strong></td>
								<td>{util.formatAsCurrency(amount)}</td>
								<td />
							</tr>
							{budgetValueRows}
							<tr>
								<td />
								<td><strong>{parentContractLabel}</strong></td>
								<td>{summary.jobCost.accountingId}</td>
								<td />
							</tr>
							{accountingIdRow}
							{affirmedRow}
							{rejectionNoteRow}
							<tr>
								<td />
								<td />
								<td> {actionButton}</td>
								<td />
							</tr>
						</tbody>
					</table>
				</div>
			</section>

		</section>
	);
};

export default class JobCostPreOrder extends React.Component<any, any> {
	constructor(props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.handleOneTimeAffirmed = this.handleOneTimeAffirmed.bind(this);
		this.handleAccountingIdChange = this.handleAccountingIdChange.bind(this);
		this.handleNoteChange = this.handleNoteChange.bind(this);

		this.publishAction  = this.publishAction.bind(this);
		this.rejectAction = this.rejectAction.bind(this);
	}

	UNSAFE_componentWillReceiveProps(newProps) {
		this.setState(this.getStateFromProps(newProps));
	}

	getStateFromProps(props) {
		const { store } = componentServices;
		const { jobCost } = props;
		const state = _.assign({ rejectionNote: '' }, this.state);
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
		const builder = (job && job.builderKey) ? getModel({ store, collection: ModelCollection.contractors, key: job.builderKey}) : undefined;
		const globalConfig = globalRelay.config!;

		if (state.jobCostKey !== jobCost.key || state.jobCostItemVersion !== jobCost.itemVersion) {
			const reviewTarget = jobCost.currentChangeOrder || jobCost;
			const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts }).filter(jc => jc.jobKey === jobCost.jobKey && jc.key !== jobCost.key && jc.currentStatus !== 'rejected');
			let firstJobContract;

			jobCosts.forEach(jc => {
				const testStatus = jc.getMostRecentStatusByStatus('approved') || jc.getMostRecentStatusByStatus('pending-approval');

				if (testStatus && (!firstJobContract || !firstJobContract.statusDate || testStatus.dateCreated < firstJobContract.statusDate || (firstJobContract.status === 'pending-approval' && testStatus.status === 'approved'))) {
					firstJobContract = { key: jc.key, statusDate: (testStatus && testStatus.dateCreated), status: (testStatus && testStatus.status) };
				}
			});

			if (reviewTarget.currentStatus !== 'pending-approval') {
				const reviewStatus = reviewTarget.getMostRecentStatusByStatus('approved') || reviewTarget.getMostRecentStatusByStatus('rejected');
				if (reviewStatus) {
					state.rejectionNote = reviewStatus.description;
				}
			}

			state.oneTimeAffirmed = jobCost.preorderSubmittedDate ? '1' : '0';
			state.accountingId = reviewTarget.accountingId;

			state.job = job;
			state.jobCostKey = jobCost.key;
			state.jobCostItemVersion = jobCost.itemVersion;
			state.firstJobContract = firstJobContract && jobCosts.get(firstJobContract.key);
		}

		state.jobTypeName = enums.businessSegments.getName(job.businessSegment);
		state.builder = builder;


		if (job.businessSegment === enums.businessSegments.Retail) {
			if (jobCost.getLineItemsByType('subtrade').length) {
				state.jobTypeName = globalConfig.getString('Ren-L');
			}
			else if (builder) {
				state.jobTypeName = job.isRenovation ? globalConfig.getString('Ren-C') : globalConfig.getString('Ret-C');
			}
			else {
				state.jobTypeName = job.isRenovation ? globalConfig.getString('Ren-H') : globalConfig.getString('Ret-H');
			}
		}

		if (!builder && job.builderKey) {
			contractorActions.fetchContractor({ key: job.builderKey });
		}

		return state;
	}

	handleOneTimeAffirmed(newButton) {
		const { jobCost } = this.props;

		if (!jobCost.preorderSubmittedDate) {
			// set state to force a re-render
			this.setState(previousState => {
				const newState = _.assign({}, previousState);

				newState.oneTimeAffirmed = newButton.value;

				return newState;
			});
		}
	}

	handleAccountingIdChange(e) {
		const { jobCost } = this.props;
		const reviewTarget = jobCost.currentChangeOrder || jobCost;
		const newVal = e.type === 'blur' ? valueFilters.clean(e.target.value) : e.target.value;

		if (!reviewTarget.preorderSubmittedDate) {
			// set state to force a re-render
			this.setState(previousState => {
				const newState = _.assign({}, previousState);

				newState.accountingId = newVal;

				return newState;
			});
		}
	}

	handleNoteChange(e) {
		const newVal = e.type === 'blur' ? valueFilters.clean(e.target.value) : e.target.value;
		// set state to force a re-render
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.rejectionNote = newVal;

			return newState;
		});
	}

	async publishAction() {
		const { store } = componentServices;
		const saveState = store.getIn(['viewState', 'globalSave', 'state']);
		const { jobCost, summary } = this.props;
		const reviewTarget = jobCost.currentChangeOrder || jobCost;
		const { oneTimeAffirmed, accountingId } = this.state;
		const options = { autoSave: true };

		if (saveState !== 0 || typeof oneTimeAffirmed === 'undefined' || oneTimeAffirmed === '0' || (oneTimeAffirmed === '1' && !accountingId) || !!jobCost.preorderSubmittedDate) { return; }

		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
		const jobsByAccountingId = await searchJobs({ accountingId });

		if(jobsByAccountingId.length) {
			pushAlert({ type: 'error', message: `This ${globalRelay.config!.getString('Accounting ID', 'job')} has already been used.`, isCloseable: true });

			return;
		}

		await reportActions.fillReportData({ summaries: [summary], job: job }).then(reportResult => {
			this.props.updateModel(jc => {
				const contract = jc.proxiedContract || jc;
				const updateTarget = jc.currentChangeOrder || contract;

				contract.preorderSubmittedDate = new Date(); // this is a wrapped settings property whose name is automatically managed to account for change orders
				updateTarget.accountingId = accountingId;

				// be sure the accounting id is correctly published
				if (reportResult) {
					reportResult.data.jobCosts[0].accountingId = accountingId;

					(options as any).extraneousPatch = [{
						op: 'replace',
						path: '../publish/preorder',
						value: reportResult
					}];
				}
			}, options);
		});
	}

	rejectAction() {
		const saveState = componentServices.store.getIn(['viewState', 'globalSave', 'state']);
		const { jobCost, summary } = this.props;
		const { rejectionNote } = this.state;
		const reviewTarget = jobCost.currentChangeOrder || jobCost;
		const options = { autoSave: true };

		if (saveState !== 0 || reviewTarget.currentStatus !== 'pending-approval' || !rejectionNote) { return; }

		this.props.updateModel(jc => {
			const contract = jc.proxiedContract || jc;
			const updateTarget = jc.currentChangeOrder || contract;
			const changeOrderKey = jc.currentChangeOrder && jc.currentChangeOrder.key;

			updateTarget.statusLog.add({ status: 'rejected', description: rejectionNote });

			summary.eraseCalculatedItems(contract, changeOrderKey);
			summary.eraseStats(contract, changeOrderKey);

			if (updateTarget.getModelName() === 'JobCost') {
				contract.paymentTerms = [];

				const scheduleItem = _.find(contract.scheduleItems, { type: jobCostScheduleItemFactory.TYPES.PROPOSED_DELIVERY });
				if (scheduleItem) { contract.scheduleItems.delete(scheduleItem.key); }
			}
			else {
				// clear the payment terms for just this change order
				_.forEach(jc.paymentTerms, ti => jc.paymentTerms.delete(ti.key));
			}
		}, options);
	}

	builderAllowed() {
		const { jobCost } = this.props;
		const { builder, job } = this.state;
		const reviewTarget = jobCost.currentChangeOrder || jobCost;
		const payment = _.first(_.orderBy(job.getSystemGeneratedPayments(reviewTarget.key), ['sortIndex']));
		const paymentPasses = jobCost.currentChangeOrder && (!payment || ['account', 'purchase-order'].indexOf(payment.transactionMethod) === -1);

		return !builder || builder.currentStatus !== 'locked' || paymentPasses;
	}

	render() {
		const { jobCost, summary } = this.props;
		const reviewTarget = jobCost.currentChangeOrder || jobCost;
		const { accountingId, oneTimeAffirmed, firstJobContract, rejectionNote } = this.state;
		const accountingIdLabel = globalRelay.config!.getString('Accounting ID', 'job');
		const resolvedAccountingId = jobCost.preorderSubmittedDate ? reviewTarget.accountingId : accountingId;

		const affirmedButtons = [
			{ classNames: ['icon yes'], isSelected: (oneTimeAffirmed === '1'), value: '1' },
			{ classNames: ['icon no'], isSelected: (oneTimeAffirmed === '0'), value: '0' }
		];
		const affirmedRow = (<tr className={(oneTimeAffirmed === '1') ? 'yes' : (oneTimeAffirmed === '0') ? 'no' : ''} key="approveRadio">
			<td />
			<td><strong>Is everything complete, correct, approved by the customer, and ready for Pre-Order?</strong></td>
			<td>
				<Radio buttons={affirmedButtons} onChange={this.handleOneTimeAffirmed} />
			</td>
			<td />
		</tr>);

		const rejectionNoteRow = oneTimeAffirmed === '0' ? (<tr className={reviewTarget.currentStatus !== 'pending-approval' ? 'disabled' : ''}>
			<td />
			<td><strong>Notes for Salesperson to make corrections</strong></td>
			<td><textarea style={{ height: '80px', minHeight: 'auto' }} value={rejectionNote} onChange={this.handleNoteChange} onBlur={this.handleNoteChange} /></td>
			<td />
		</tr>) : null;

		const accountingIdRow = (<tr className={(!oneTimeAffirmed || !!jobCost.preorderSubmittedDate) ? 'disabled' : ''}>
			<td />
			<td><strong>{accountingIdLabel}</strong></td>
			<td><input type="text" className="" placeholder={`Enter the ${accountingIdLabel}`} autoCapitalize="" autoCorrect="off" value={util.reactVal(resolvedAccountingId)} onChange={this.handleAccountingIdChange} onBlur={this.handleAccountingIdChange} /></td>
			<td />
		</tr>);

		const submitButtonClasses = ['action', 'iconLabel', 'finalize'];
		const builderPasses = this.builderAllowed();

		if (!builderPasses || typeof oneTimeAffirmed === 'undefined' || oneTimeAffirmed === '0' || (oneTimeAffirmed === '1' && !accountingId) || !!jobCost.preorderSubmittedDate || reviewTarget.currentStatus !== 'pending-approval') {
			submitButtonClasses.push('disabled');
		}

		const submitButton = (<AsyncButton className={submitButtonClasses.join(' ')} asyncAction={this.publishAction} label="Accept" />);
		const rejectButton = (<AsyncButton className={`action iconLabel reject${reviewTarget.currentStatus !== 'pending-approval' || !rejectionNote ? ' disabled' : ''}`} asyncAction={this.rejectAction} label="Reject" />);

		return (jobCost.currentChangeOrder)
			? (<JobCostPreOrderChangeOrder accountingIdRow={accountingIdRow} affirmedRow={affirmedRow} actionButton={oneTimeAffirmed === '1' ? submitButton : rejectButton} summary={summary} rejectionNoteRow={rejectionNoteRow} changeOrder={jobCost.currentChangeOrder} {...this.state} />)
			: (<JobCostPreOrderContract accountingIdRow={accountingIdRow} affirmedRow={affirmedRow} firstJobContract={firstJobContract} job={this.state.job} jobTypeName={this.state.jobTypeName} actionButton={oneTimeAffirmed === '1' ? submitButton : rejectButton} summary={summary} rejectionNoteRow={rejectionNoteRow} {...this.state} />);
	}
}
